import { render } from "./TdmTest.vue?vue&type=template&id=f18875c2&scoped=true&ts=true"
import script from "./TdmTest.vue?vue&type=script&lang=ts"
export * from "./TdmTest.vue?vue&type=script&lang=ts"

import "./TdmTest.vue?vue&type=style&index=0&id=f18875c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18875c2"]])

export default __exports__